<crm-single-select
  #singleSelectComponent
  [options]="entities"
  [(selectedItem)]="_selectedEntity"
  (selectedItemChange)="onSelect($event)"
  [label]="isFloatLabel ? 'ИИ агент' : ''"
  [virtualScroll]="true"
  [virtualScrollItemSize]="33"
  [showClear]="showClear"
  [placeholder]="placeholder"
  [styleClass]="styleClass + (isError ? ' ng-invalid ng-dirty' : '')"
  [class]="class + (isError ? ' ng-invalid ng-dirty' : '')"
  [appendTo]="appendTo"
  [disabled]="disabled"
  filterBy="name"
  [loading]="selectionLoading"
  (onShow)="onShowPanel()"
  (onFilter)="search($event.filter)">
  <ng-template #footerTemplate>
    <crm-spinner
      *ngIf="paginationLoading"
      top=""
      text=""
      [height]="35"
      [width]="35"
      bottom=""></crm-spinner>
  </ng-template>
</crm-single-select>
